import React, { Component } from 'react';
import ContainerDivided from 'screens/components/basic/ContainerDivided';
import LOOKUP from 'constants/lookup';
import { Link } from 'react-router-dom';
import TextInput from 'screens/components/basic/TextInput';
import Button from 'screens/components/basic/Button';
import Chip from '@mui/material/Chip';
import RadioInput from 'screens/components/basic/RadioInput';

// import TextInput from 'screens/components/basic/TextInput';
// import DialogInput from 'screens/components/advanced/DialogInput';
// import { formError, formInput, clearAdminOrderCancellation } from 'actions/FormActions';
// import { showSnackbar, showError } from 'actions/CommonActions';
// import GenericTable from 'screens/components/advanced/GenericTable';
// import { getOpenOrders, cancelOrder } from 'actions/EntityActions';
// import Pagination from 'screens/components/basic/Pagination';
// import util from 'library/util';

const options = [
    {
        text: 'Add Menu',
        value: '1'
    },
    {
        text: 'Add Category',
        value: '2'
    }
];

class WebAddMenuPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            menuData: [
                { key: 0, label: 'Flowers' },
                { key: 1, label: 'Concentrates' },
                { key: 2, label: 'Edibles' },
                { key: 3, label: 'Tropicals & Tinctures' }
            ],
            categoryData: [
                { key: 0, label: 'Sativa' },
                { key: 1, label: 'Indica' },
                { key: 2, label: 'Hybrid' }
            ]
        };

        this.styles = {
            chip: {
                margin: 4
            },
            wrapper: {
                display: 'flex',
                flexWrap: 'wrap'
            }
        };

    }


    handleMenuDelete = (key) => {
        this.menuData = this.state.menuData;
        const chipToDelete = this.menuData.map((chip) => chip.key).indexOf(key);
        this.menuData.splice(chipToDelete, 1);
        this.setState({ menuData: this.menuData });
    };

    handleCategoryDelete = (key) => {
        this.categoryData = this.state.categoryData;
        const chipToDelete = this.categoryData.map((chip) => chip.key).indexOf(key);
        this.categoryData.splice(chipToDelete, 1);
        this.setState({ categoryData: this.categoryData });
    }

    renderMenuChip(data) {
        return (
            <Chip
                className="menu_chip"
                key={data.key}
                onDelete={() => this.handleMenuDelete(data.key)}
                sx={this.sxs.chip}
                label= {data.label}
            />

        );
    }

    renderCategoryChip(data) {
        return (
            <Chip
                className="menu_chip"
                key={data.key}
                onDelete={() => this.handleCategoryDelete(data.key)}
                sx={this.styles.chip}
                label={data.label}
            />
        );
    }

    render() {
        // const p = this.props;
        // const s = this.state;
        const radioSelected = this.props.radioSelected;
        const header = (
            <div>
                <ol className="breadcrumb">
                    <li><Link to={LOOKUP.menu.home.link}>{LOOKUP.menu.home.text}</Link></li>
                    <li className="active"><Link to={LOOKUP.menu.admin.addMenu.link}>{LOOKUP.menu.admin.addMenu.text}</Link></li>
                </ol>
                <h2>{LOOKUP.menu.admin.addMenu.text}</h2>
            </div>
        );

        return (
            <ContainerDivided headerContent={header}>
                <div className="web_add_menu_wrapper">
                    <div className="container">
                        <div className="row d-flex justify-content-center">
                            <div className="col-xs-12 col-sm-5 col-md-4 col-lg-4 col-xl-4 p-0">
                                <h4>Menu</h4>
                            </div> {/* .col */}
                            <div className="col-xs-12 col-sm-5 col-md-4 col-lg-4 col-xl-4 p-0">
                                <h4>Category</h4>
                            </div> {/* .col */}
                        </div> {/* .row */}

                        <div className="row d-flex justify-content-center">
                            <div className="col-xs-12 col-sm-5 col-md-4 col-lg-4 col-xl-4 mr-2">
                                <div className="add_menu_wrapper">
                                    <div style={this.styles.wrapper}>
                                        {this.state.menuData.map(this.renderMenuChip, this)}
                                    </div>
                                </div> {/* .add_menu_wrapper */}
                            </div> {/* .col */}

                            <div className="col-xs-12 col-sm-5 col-md-4 col-lg-4 col-xl-4">
                                <div className="add_category_wrapper">
                                    <div style={this.styles.wrapper}>
                                        {this.state.categoryData.map(this.renderCategoryChip, this)}
                                    </div>
                                </div> {/* .add_category_wrapper */}
                            </div> {/* .col */}
                        </div> {/* .row */}

                        <div className="row d-flex justify-content-center mt-5">
                            <div className="col-xs-12 col-sm-10 col-md-5 col-lg-5 col-xl-5 add_menu_option">
                                <RadioInput
                                    groupName="AddNewMenuOption"
                                    options={options}
                                    fullWidth={false} />
                            </div> {/* .col */}
                        </div> {/* .row */}

                        <div className="row d-flex justify-content-center">
                            <div className="col-lg-4">

                                {
                                    radioSelected === '1'

                                        ?
                                        <TextInput
                                            hintText="Add Menu"
                                            floatingLabelText="Add Menu"
                                            multiLine={false}
                                            rows={1}
                                            fullWidth={true}
                                            name="addMenu"
                                        />
                                        :
                                        <TextInput
                                            hintText="Add Category"
                                            floatingLabelText="Add Category"
                                            multiLine={false}
                                            rows={1}
                                            fullWidth={true}
                                            name="addCategory"
                                        />
                                }

                            </div> {/* .col */}
                            <div className="col-lg-3 mt-2">
                                <Button type="button" label="Add" className="add_menu_btn" />
                            </div> {/* .col */}
                        </div> {/* .row */}

                    </div> {/* .container */}
                </div> {/* .web_add_menu_wrapper */}
            </ContainerDivided>
        );
    }
}


export default WebAddMenuPage;